import { Injectable } from '@angular/core';

import { MatterDate } from '../../models/matter-date';

import { HttpClientService } from '../common/http-client.service';

@Injectable()
export class MatterDateService {
  /**
   * URL for matter dates controller
   * @type {String}
   */
  private matterDatesURL = 'matter_dates';

  /**
   * Constructor
   * @param {HttpClientService} private httpClient Service for making HTTP requests with different methods
   */
  constructor(private httpClient: HttpClientService) {}

  /**
   * Delete matter date
   * @param  {MatterDate}   matter_date Matter date to delete
   * @return {Promise<any>}             Server response with request result
   */
  deleteMatterDate(matter_date: MatterDate): Promise<any> {
    return this.httpClient.delete(`${this.matterDatesURL}/${matter_date.id}.json`);
  }

  /**
   * Get matter dates of matter
   * @param  {any}          search_params Search params for matter dates
   * @return {Promise<any>}               Server response with matter dates
   */
  getMatterDates(search_params: any): Promise<any> {
    search_params.get_matter_dates = true;
    return this.httpClient.get(`${this.matterDatesURL}.json`, search_params);
  }

  /**
   * Get form options for matter dates form
   * @return {Promise<any>} Server response with form options
   */
  getFormOptions(): Promise<any> {
    return this.httpClient.get(`${this.matterDatesURL}.json`, { get_form_options: true });
  }

  /**
   * Get matter date
   * @param  {any}          id Id of matter date
   * @return {Promise<any>}    Server response with matter date
   */
  getMatterDate(id: any): Promise<any> {
    return this.httpClient.get(`${this.matterDatesURL}/${id}.json`, { get_matter_date: true });
  }

  /**
   * Save matter date
   * @param  {MatterDate}   matter_date Matter date to save
   * @return {Promise<any>}             Server response of request result
   */
  saveMatterDate(matter_date: MatterDate): Promise<any> {
    if (matter_date.id) return this.httpClient.put(`${this.matterDatesURL}/${matter_date.id}.json`, { matter_date: matter_date, save_matter_date: true });
    else return this.httpClient.post(`${this.matterDatesURL}.json`, { matter_date: matter_date, save_matter_date: true });
  }
}
